import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { switchMap, catchError, of } from 'rxjs';
import * as CoreUiActions from './core-ui.actions';
import * as CoreUiFeature from './core-ui.reducer';

@Injectable()
export class CoreUiEffects {
  private actions$ = inject(Actions);

}
